import axios from "../axios";
const END_POINT = "/holidays";


const AddHoliday = (payload) => axios.post(`${END_POINT}`, payload);
const findHoliday = (id) => axios.get(`${END_POINT}/${id}`)
const SearchHoliday = (payload) => axios.post(`${END_POINT}/search`, payload);
const UpdateHoliday =  (id, payload) => axios.patch(`${END_POINT}/${id}`, payload);
const deleteHoliday = (id) => axios.delete(`${END_POINT}/${id}`);
;

export {
    SearchHoliday,
    AddHoliday,
    UpdateHoliday,
    deleteHoliday,
    findHoliday

};